import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    actionContext: {}, //context values used in doActions from clicked items
    currentId: null,
    anchor: { //anchor used to defined is opened context menu
        mouseX: null,
        mouseY: null,
    },
    anchorTarget: null
};


export const contextMenuSlice = createSlice({
    name: 'contextMenu',
    initialState,
    reducers: {
        openContextMenu: (state, action) => {
            state.anchor = action.payload.anchor;
            state.anchorTarget = action.payload.anchorTarget;
            state.currentId = action.payload.currentId;
            state.actionContext = action.payload.actionContext;
        },
        closeContextMenu: state => {
            state.anchor = initialState.anchor;
            state.anchorTarget = initialState.anchorTarget;
            state.currentId = initialState.currentId;
            state.actionContext = initialState.actionContext;
        }
    }
})

export const {
    openContextMenu,
    closeContextMenu
} = contextMenuSlice.actions;

export default contextMenuSlice.reducer;